/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="./vehicle_interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class Vehicle implements IDealerwareVehicle {
        // Properties
        public static $inject: string[] = [
            '$q',
            '$timeout',
            'DealerwareVehicleModel',
            '$DealerwareNotesFactory',
            '$injector'
        ];

        private _locationId: number;
        private _vehicleId: number;
        private NotesCollection: IDealerwareNotesCollection;
        public vehicleDetails: any;
        public qrCode: any;
        public vehicleStates: any;
        public vehicleIssues: any;
        public vehicleScans: any;
        public vehicleContracts: any;
        public tollHistory: any;

        // Constructor
        constructor(public $q: any,
            public $timeout: any,
            public DealerwareVehicleModel: any,
            public $DealerwareNotesFactory : any) {}

        // Accessors
        get noteCollection() : IDealerwareNotesCollection {
            if (!this.NotesCollection && this.vehicleId) {
                this.NotesCollection = this.$DealerwareNotesFactory.getVehicleInstance(this.vehicleDetails.data.location_id, this.vehicleId);
            }
            return this.NotesCollection;
        }

        get locationId() : number {
            return this._locationId;
        }

        set locationId(id: number) {
            this._locationId = id;
        }

        get vehicleId() : number {
            return this._vehicleId;
        }

        set vehicleId(id: number) {
            if (id !== this._vehicleId) {
                this.clear();
            }

            this._vehicleId = id;
        }

        // Methods
        public clear() : void {
            this.clearVehicleDetails();
        }

        public clearVehicleDetails() : void {
            this.vehicleDetails = undefined;
        }

        public loadVehicleDetails(locationId?: number, id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (locationId) { this.locationId = locationId; }
            if (id) { this.vehicleId = id; }

            if (!this.locationId) {
                _deferred.reject({response: {data: {message: 'Location ID is undefined'}}});
            } else if (!this.vehicleId) {
                _deferred.reject({response: {data: {message: 'Vehicle ID is undefined'}}});
            } else {
                this.DealerwareVehicleModel.loadVehicleDetails({
                    params: {
                        id: this.vehicleId,
                        location_id: this.locationId,
                        include_location: true
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleDetails = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadQrCode(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.vehicleId = id; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.vehicleId) {
                _deferred.reject({ response: { data: { message: 'Vehicle ID is undefined' }}});
            } else {
                this.DealerwareVehicleModel.loadQrCode({
                    params: {
                        location_id: this.locationId,
                        id: this.vehicleId
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.qrCode = window.URL.createObjectURL(
                            new Blob([response.data], { type: "image/svg+xml" })
                        );
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) { _deferred.reject({ response: response }); }
                });
            }

            return _deferred.promise;
        }

        public loadVehicleStates(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.vehicleId = id; }

            if (!this.locationId) {
                _deferred.reject({response: {data: {message: 'Location ID is undefined'}}});
            } else if (!this.vehicleId) {
                _deferred.reject({response: {data: {message: 'Vehicle ID is undefined'}}});
            } else {
                this.DealerwareVehicleModel.loadVehicleStates({
                    params: {
                        location_id: this.locationId,
                        id: this.vehicleId
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleStates = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public updateVehicleState(id: number, newState: string) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            this.DealerwareVehicleModel.updateVehicleState({
                params: {
                    id: id,
                    new_state: newState
                },
                successCallback: function(returnValue: any, response: any) {
                    _self.vehicleDetails = returnValue;
                    _deferred.resolve({ returnValue: returnValue, response: response });
                },
                errorCallback: function(response: any) {
                    _deferred.reject({ response: response });
                }
            });

            return _deferred.promise;
        }


        public loadVehicleIssues(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.vehicleId = id }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.vehicleId) {
                _deferred.reject({ response: { data: { message: 'Vehicle ID is undefined' }}});
            } else {
                this.DealerwareVehicleModel.loadVehicleIssues({
                    params: {
                        location_id: this.locationId,
                        vehicle_id: this.vehicleId,
                        sort_by: 'created_at',
                        sort_direction: 'desc'
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleIssues = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadVehicleScans() : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (!this.vehicleId) {
                _deferred.reject({ response: { data: { message: 'Vehicle ID is undefined' }}});
            } else {
                this.DealerwareVehicleModel.loadVehicleScans({
                    params: {
                        location_id: this.vehicleDetails.data.location_id,
                        vehicle_id: this.vehicleId,
                        sort_by: 'event_received_at',
                        sort_direction: 'desc'
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleScans = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadVehicleContracts(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (id) { this.vehicleId = id; }

            if (!this.locationId) {
                _deferred.reject({response: {data: {message: 'Location ID is undefined'}}});
            } else if (!this.vehicleId) {
                _deferred.reject({response: {data: {message: 'Vehicle ID is undefined'}}});
            } else {
                this.DealerwareVehicleModel.loadVehicleContracts({
                    params: {
                        location_id: this.locationId,
                        vehicle_id: this.vehicleId,
                        sort_by: 'created_at',
                        sort_direction: 'desc',
                        include_reservation: true,
                        include_customer: true
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleContracts = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        _deferred.reject({ response: response });
                    }
                });
            }

            return _deferred.promise;
        }

        public loadNotes() : ng.IPromise<{}> {
            var _self = this;
            var _deferred = this.$q.defer();
            this.noteCollection.loadNotes().then(
                function(response) {
                    _deferred.resolve(response);
                },
                function(response) {
                    _deferred.reject(response);
                }
            );

            return _deferred.promise;
        }

        public loadTollHistory(id?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

                if (id) { this.vehicleId = id; }

                if (!this.locationId) {
                    _deferred.reject({response: {data: {message: 'Location ID is undefined'}}});
                } else if (!this.vehicleId) {
                    _deferred.reject({response: {data: {message: 'Vehicle ID is undefined'}}});
                } else {
                    this.DealerwareVehicleModel.loadTollHistory({
                        params: {
                            location_id: this.locationId,
                            vehicle_id: this.vehicleId,
                            sort_by: 'tolled_at',
                            sort_direction: 'desc'
                        },
                        successCallback: function(returnValue: any, response: any) {
                            _self.tollHistory = returnValue;
                            _deferred.resolve({ returnValue: returnValue, response: response });
                        },
                        errorCallback: function(response: any) {
                            _deferred.reject({ response: response });
                        }
                    });
                }

                return _deferred.promise;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareVehicle", Vehicle);
}
